function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 210
// module chunks = 0